export default {
    mounted(){
        window.addEventListener('message', e => {
            if(typeof this.onFrameMessage === 'function'){
                this.onFrameMessage(e.data, e.origin, e.source, e)
            }
        });
    },
    methods: {
        sendFrameMessage(data, options = {}){
            const {
                targetOrigin = '*',
                target
            } = options;
            const isTop = self === top;

            if(target){
                target.postMessage(data, targetOrigin);
            }else if(isTop){
                window.frames[0].postMessage(data, targetOrigin);
            }else if(!isTop){
                window.parent.postMessage(data, targetOrigin);
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/mixins/frame.js